import { connect } from 'react-redux';
import { logOut } from '@zippeditoolsjs/heimdal-react';
import ProfileForm from '../../../components/profile/sections/ProfileForm';
import { patchProfile } from 'core/slices/profile';
import { getSessionCookie, nistCheckPassword } from 'core/slices/session';
import { userProfile, isLoadingProfile } from 'core/selectors';
import { hasValidatePasswordResponse } from 'core/selectors';

export default connect(
  state => ({
    userProfile: userProfile(state),
    isLoadingProfile: isLoadingProfile(state),
    hasValidatePasswordResponse: hasValidatePasswordResponse(state),
  }),
  { patchProfile, nistCheckPassword, getSessionCookie, logOut },
)(ProfileForm);
